module.exports = __webpack_public_path__ + "img/banner_10.628b4f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_10.jpg
// module id = vcXg
// module chunks = 0